import React from 'react';
import { Breadcrumb } from 'antd';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useMediaQuery } from 'react-responsive';
import { Container } from 'react-bootstrap';
import Footer from '../../Footer';
import './Secteurs.css';
import { useTranslation } from 'react-i18next';

const Secteurs = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { t, i18n } = useTranslation();

  
  return (
    <>
    <HelmetProvider>
      <div className='container_SA'>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{t('Professional Inspectors - Secteur d\'Intervention')}</title>
          <meta
            name="description"
            content={t('Découvrez nos services d\'inspection et de contrôle de qualité dans divers secteurs...')}
            />
          <meta
            name="keywords"
            content={t('inspection, contrôle qualité, pétrole et gaz, énergie et mines, construction métallique, industrie, services, soudage, contrôle non destructif, intégrité des équipements, sécurité incendie, corrosion')}
            />
        </Helmet>

        <Container fluid={isDesktopOrLaptop ? false : true}>
          <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
          <Breadcrumb.Item>{t('Secteurs')}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>

        <div className="tabs-to-dropdown">
          <div className={`d-flex ${isDesktopOrLaptop ? 'justify-content-between align-items-start' : 'flex-column align-items-center'}`}>
            <div className="nav-wrapper">
              <ul className={`nav nav-pills ${isDesktopOrLaptop ? 'd-md-flex' : 'd-flex d-md-none'}`} id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="pills-pg-tab" data-toggle="pill" href="#pills-pg" role="tab" aria-controls="pills-pg" aria-selected="true">{t('Pétrole et gaz')}</a>
                </li>
              <li className="nav-item" role="presentation">
                <a className="nav-link" id="pills-em-tab" data-toggle="pill" href="#pills-em" role="tab" aria-controls="pills-em" aria-selected="false">{t('Energie et mines')}</a>
              </li>
              <li className="nav-item" role="presentation">
                <a className="nav-link" id="pills-cm-tab" data-toggle="pill" href="#pills-cm" role="tab" aria-controls="pills-cm" aria-selected="false">{t('Construction métallique')}</a>
              </li>
              <li className="nav-item" role="presentation">
                <a className="nav-link" id="pills-i-tab" data-toggle="pill" href="#pills-i" role="tab" aria-controls="pills-sm" aria-selected="false">{t('Industrie')}</a>
              </li>
              <li className="nav-item" role="presentation">
                <a className="nav-link" id="pills-ser-tab" data-toggle="pill" href="#pills-ser" role="tab" aria-controls="pills-ser" aria-selected="false">{t('Services')}</a>
              </li>
            </ul>
          </div>

          <div className="tab-content" id="pills-tabContent">
  
              <div className="tab-pane fade show active" id="pills-pg" role="tabpanel" aria-labelledby="pills-pg-tab">
                <div className="container-fluid">
                  <h2 className="mb-3 font-weight-bold">{t('Pétrole et gaz')}</h2>
                  <div className="rows about">
                  <div className="col-sm-12">

                    <div className="pics us">
                      <img src="images/pg.jpg" className="img-fluid intro_image_S" alt="Pétrole et gaz" />
                    </div>
                  </div>
                  <ul>
                      <br></br>
                      <li>{t("Dans le secteur pétrolier, des activités d'inspection rigoureuses sont mises en œuvre pour garantir la qualité et la sécurité des opérations. Cela englobe divers aspects essentiels :")}</li>
                    </ul>
                    <ul>
                      <li>{t('-Inspection des tuyaux de forage et des accessoires.')}</li>
                      <li>{t('-Inspection des tuyaux de transport des hydrocarbures et de leurs accessoires.')}</li>
                      <li>{t('-Vérification de l\'intégrité des tiges de succion. ')}</li>
                      <li>{t('-Tarage des soupapes.')}</li>
                    </ul>
                    <ul>
                      <li>{t('-Inspection périodique des structures mécano-soudées. ')}</li>
                      <li>{t('-Inspection des équipements de manutention et des installations.')}</li>
                      <li>{t('-Test de pression, étalonnage et essai hydrostatique. ')}</li>
                      <li>{t('-Inspection  périodique des équipements de levage et des accessoires associés. ')}</li>
                      <li>{t('-Inspection périodique des installations intérieures électriques et des installations de gaz.')}</li>
                    </ul>
              </div>
              </div>
            </div>

            <div className="tab-pane fade" id="pills-em" role="tabpanel" aria-labelledby="pills-em-tab">
            <div className="container-fluid tab-pane-container">
              <h2 className="mb-3 font-weight-bold">{t('Energie et mines')}</h2>
                <div className="rows about">
                  <div className="col-sm-12">
                    <div className="pics us">
                      <img src="images/em.jpg" className="img-fluid intro_image_S" />
                    </div>
                  </div>
                </div>

                <ul>
                      <li>{t('Soudage')}</li>
                      <li>{t('Contrôle non destructif')}</li>
                      <li>{t('Intégrité des équipements et des installations')}</li>
                      <li>{t('Corrosion')}</li>
                      <li>{t('Sécurité incendie')}</li>
                      <li>{t('Réception et suivi des ouvrages')}</li>
                    </ul>

              </div>
            </div>

            <div className="tab-pane fade" id="pills-cm" role="tabpanel" aria-labelledby="pills-cm-tab">
            <div className="container-fluid tab-pane-container">
                              <h2 className="mb-3 font-weight-bold">{t('Construction métallique')}</h2>
                <div className="rows about">
                  <div className="col-sm-12">
                    <div className="pics us">
                      <img src="images/cm1.jpg" className="img-fluid intro_image_S" />
                    </div>
                  </div>
                </div>
                <ul>
                      <li>{t('Soudage')}</li>
                      <li>{t('Contrôle non destructif')}</li>
                      <li>{t('Intégrité des équipements et des installations')}</li>
                      <li>{t('Corrosion')}</li>
                      <li>{t('Sécurité incendie')}</li>
                      <li>{t('Réception et suivi des ouvrages')}</li>
                    </ul>
              </div>
            </div>

            <div className="tab-pane fade" id="pills-i" role="tabpanel" aria-labelledby="pills-i-tab">
              <div className="container-fluid tab-pane-container">
                <h2 className="mb-3 font-weight-bold">{t('Industrie')}</h2>
                <div className="rows about">
                  <div className="col-sm-12">
                    <div className="pics us">
                      <img src="images/i.jpg" className="img-fluid intro_image_S" />
                    </div>
                  </div>
                </div>
                <h2>{t('CONTROLE REGLEMENTAIRE DE SECURITE (CRS)')}</h2>
                    <ul>
                      <li>{t('Contrôle des appareils à pression de vapeur A1')}</li>
                      <li>{t('Contrôle des appareils à pression de gaz A2')}</li>
                      <li>{t('Contrôle des ouvrages de transport de gaz combustibles par canalisation A3')}</li>
                      <li>{t('Contrôle des installations de gaz dans les domaines industriels B1')}</li>
                      <li>{t('Contrôle des installations électriques dans les domaines industriels B2')}</li>
                      <li>{t('Contrôle des appareils de levage et des ascenseurs et monte-charges B3')}</li>
                      <li>{t('Contrôle des moyens de prévention et de lutte contre les incendies')}</li>
                    </ul>
              </div>
            </div>

            <div className="tab-pane fade" id="pills-ser" role="tabpanel" aria-labelledby="pills-ser-tab">
              <div className="container-fluid tab-pane-container">
                <h2 className="mb-3 font-weight-bold">{t('Services')} </h2>
                <div className="rows about">
                  <div className="col-sm-12">
                    <div className="pics us">
                      <img src="images/ser.jpg" className="img-fluid intro_image_S" />
                    </div>
                  </div>
                </div>
                <ul>
                      <li>{t('Mesure épaisseur des navires.')}</li>
                      <li>{t('Evaluation des risques incendie')}</li>
                      <li>{t('Evaluation des risques environnementaux')}</li>
                      <li>{t('Inspection des bouées et des chaînes d\'amarrage.')}</li>
                      <li>{t('Inspection des chargements.')}</li>
                    </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
    </HelmetProvider>
    </>
  );
};

export default Secteurs;
